export const ComputeResource = {
  "Header_LeftBracket": "左括号",
  "Headrt_Data": "数据",
  "Headrt_Operator": "操作符",
  "Headrt_Value": "值",
  "Headrt_RightBracket": "右括号",
  "Headrt_Relation": "关系",
  "Data_Code": "编号",
  "Data_Name": "名称",
  "Relation_And": "并且",
  "Relation_Or": "或者",
  "Notice_Success": "表达式生成！",
  "Notice_NotComplate": "请确保必填项填写完整！",
  "Notice_SuccessClear": "条件已清空！",
  "Notice_PleaseSelectRow": "请先选中一行条件！",
  "Notice_NotAllowSelectRoot": "禁止选择根节点！",
  "Error_Data_Oper": "条件第 %s 行 数据、操作符 未设置！",
  "Error_Data": "条件第 %s 行 数据 未设置！",
  "Error_Oper": "条件第 %s 行 操作符 未设置！",
  "Error_ValueNotSet": "条件第 %s 行 值 未设置！",
  "Error_Bracket": "条件括号闭合异常, 请检查！",
  "Button_Advaned": "高级表达式",
  "Button_Save": "确定",
  "Button_Reset": "重置",
  "Button_Cancel": "取消",
  "HeadButton_Up": "上移",
  "HeadButton_Down": "下移",
  "HeadButton_Top": "置顶",
  "HeadButton_Bottom": "置底",
  "ComputeExpression": "条件表达式",
  "AdvancedExpression": "高级表达式",
  "Advanced_Save": "保存",
  "Advanced_Cancel": "取消",
  "DeleteConfirmLeft": "确认删除第 ",
  "DeleteConfirmRight": " 行数据?"
}